import { useEffect, useRef } from 'react'
import { gsap } from 'lib/motion'

/**
 * Animates every descendant carrying a `data-anim` attribute with a staggered
 * fade-and-rise entrance when the view mounts. Attach the returned ref to the
 * view's root element. Respects prefers-reduced-motion.
 */
export function useGsapEntrance<T extends HTMLElement = HTMLDivElement>() {
  const scope = useRef<T>(null)

  useEffect(() => {
    if (!scope.current) return undefined

    const ctx = gsap.context(() => {
      const mm = gsap.matchMedia()
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        gsap.from('[data-anim]', {
          opacity: 0,
          y: 20,
          scale: 0.985,
          duration: 0.55,
          ease: 'power3.out',
          stagger: 0.07,
          clearProps: 'all',
        })
      })
    }, scope)

    return () => ctx.revert()
  }, [])

  return scope
}

export default useGsapEntrance
